import { useEffect } from 'react';
import Lenis from '@studio-freight/lenis';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export const SmoothScrollProvider = ({ children }) => {
    useEffect(() => {
        // Initialize Lenis
        const lenis = new Lenis({
            duration: 1.2,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            direction: 'vertical',
            gestureDirection: 'vertical',
            smooth: true,
            mouseMultiplier: 1,
            smoothTouch: false,
            touchMultiplier: 2,
            infinite: false,
        });

        // Connect Lenis with GSAP ScrollTrigger
        lenis.on('scroll', ScrollTrigger.update);

        function update(time) {
            lenis.raf(time * 1000);
        }

        gsap.ticker.add(update);

        gsap.ticker.lagSmoothing(0);

        // Smooth scroll for anchor links
        const handleAnchorClick = (e) => {
            const target = e.target.closest('a[href^="#"]');
            if (target) {
                const id = target.getAttribute('href').slice(1);
                const element = document.getElementById(id);
                if (element) {
                    e.preventDefault();
                    lenis.scrollTo(element, { offset: -80 });
                }
            }
        };

        document.addEventListener('click', handleAnchorClick);

        // MutationObserver to stop/start Lenis when body overflow is changed
        const observer = new MutationObserver(() => {
            if (document.body.style.overflow === 'hidden') {
                lenis.stop();
            } else {
                lenis.start();
            }
        });

        observer.observe(document.body, {
            attributes: true,
            attributeFilter: ['style']
        });

        // Cleanup
        return () => {
            observer.disconnect();
            lenis.destroy();
            gsap.ticker.remove(update);
            document.removeEventListener('click', handleAnchorClick);
            ScrollTrigger.getAll().forEach(trigger => trigger.kill());
        };
    }, []);

    return <>{children}</>;
};
